import React, {useContext, useEffect, useState} from 'react';

import Modal from 'react-modal';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

import {
    cleanStandardData
} from '../../utils/cleanRawData'
import constructName from '../../utils/constructName'
////import { universidades_engineData } from "../../data";

import '../../styles/profile.css'

import {
    getConfig,
    buildSearchesOptionsConfig
  } from "../../config/config-investigadores";
import { Grid } from '@material-ui/core';
import { UniversityContext } from '../../routes/AppRouter';

const { searchKey, endpointBase } = getConfig();
/* const connector = new AppSearchAPIConnector({
  searchKey,
  engineName,
  hostIdentifier,
  endpointBase
}); */
const config = {
/*   searchQuery: {
    facets: buildFacetConfigFromConfig(),
    ...buildSearchOptionsFromConfig()
  },
  autocompleteQuery: buildAutocompleteQueryConfig(),
  apiConnector: connector,
  alwaysSearchOnInitialLoad: true, */
  searchesOption: buildSearchesOptionsConfig()
};


const AppSearchClient = require('@elastic/app-search-node')
  
const baseUrlFn = () => endpointBase + '/api/as/v1/';
const clientDirect = new AppSearchClient(undefined, searchKey, baseUrlFn);

Modal.setAppElement('#root');
//modal de investigador abierto desde un centro(es una copia de profile.js)

export default ( props )=> {
    const [ universidad ] = useContext(UniversityContext)
    console.log(universidad.id+ ' EN modal de investigador')
    const [data, setData] = useState(null)
    const [dataLabel, setDataLabel] = useState('Cargando informacion...')

    useEffect(() => {
        getInvestigador(props.rut);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getInvestigador = (rut)=> {
        const tmpRut = ('"').concat(rut).concat('"').replaceAll("<em>","").replaceAll("</em>","");
        const searches = [
          { query: tmpRut, options:config.searchesOption }
        ];
        clientDirect
          .multiSearch(universidad.investigadores.engineName, searches)
          .then(response => {
              setData( response[0].results[0]);
              if(response[0].results[0].length!==0)
              { 
                  setDataLabel('')
              }
            })
          .catch(error => { console.log('Error en el cargado de la data '+error.errorMessages); setData(undefined); setDataLabel('No se pudo consultar registros') });
    }

    const isDataEmpy= ( data )=>{
        if( !!data && data !=='null' ){
            return false
        }else{
            return true
        }
    }


    return (
        data ?
        <>
            <div className="modal-title">
                <Grid container wrap="nowrap" spacing={2}>
                    <Grid 
                        container 
                        item
                        xs={2}
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                    >
                            <img 
                                src={ `/avatar/${props.rut}.jpg` }
                                onError={ (e)=> {e.target.onerror = null; e.target.src="https://external-content.duckduckgo.com/iu/?u=http%3A%2F%2Fzancada.com%2Fwp-content%2Fimagenes%2F2012%2F12%2Ffacebook-profile-picture-n-copy.jpg&f=1&nofb=1"} } 
                                alt="Foto de perfil del investigador" 
                                className="modal-avatar"
                            />
                    </Grid>
                    <Grid item xs>
                        <ul className="modal-userData">
                            <li className="modal-userData__name">
                                { constructName(data).replaceAll("<em>","").replaceAll("</em>","") }  
                            </li>

                            <li className="modal-userData__info">
                                { data.universidad?.raw }
                            </li>

                            <li className="modal-userData__info">
                            {
                                data.centro.raw === null || data.centro.raw === "N/A" || data.centro.snippet === "N"
                                ? ""
                                : <span dangerouslySetInnerHTML={{__html: data.centro?.raw}}></span>
                            }
                            </li>
                        </ul>
                    </Grid>
                </Grid>
            </div>

            <div className="modal-body">

                <div className="modal-profile">
                    <div className="modal-profile-header">
                    
                    </div>
                </div>
                <div className="modal-tabs">
                    <Tabs >
                        <TabList>
                            <Tab>
                                <b className="tab-title">Overview</b>
                            </Tab>
                            <Tab>
                                <b className="tab-title">Investigación</b>
                            </Tab>
                            <Tab >
                                <b className="tab-title">Publicaciones</b>
                            </Tab>
                            <Tab>
                                <b className="tab-title">Proyectos</b>
                            </Tab>
                            <Tab className="react-tabs__tab Tab-PI">
                                <b className="tab-title">Prop. Intelectual</b>
                            </Tab>
                            {
                                ( data.centro.raw !== '' || ! (!!data.centro.raw) || data.centro.raw !== "N/A" || data.centro.raw !== "N") && (
                                    <Tab>
                                        <b className="tab-title">Centro</b>
                                    </Tab>
                                )
                            }
                        </TabList>

                        {/* Overview */}
                        <TabPanel> 
                            <div>
                                <h4>Estudios</h4>
                                <ul>
                                    {
                                        data.profesion?.raw && (
                                            data.profesion?.raw.split('|').map( (individualProfesion,index)=>
                                                {
                                                    return <li key={index}>{individualProfesion}</li>
                                                } 
                                            )
                                        )
                                    }
                                    
                                    {
                                        !isDataEmpy( data.nombre_titulo_grado?.raw ) && (
                                            data.nombre_titulo_grado?.raw.split(',').map( (individualTitleGradeName,index)=>
                                                {
                                                    return <li key={index}>{individualTitleGradeName.toLowerCase()}</li>
                                                } 
                                            )
                                        )
                                    }
                                </ul>                          
                            </div>    
                            { data.directorios_empresariales_en_los_ultimos_24_meses.snippet === 'No' || data.directorios_empresariales_en_los_ultimos_24_meses.snippet === null 
                                ? <div></div>
                                : <div><h4>Directorios empresariales últimos 24 meses</h4><span dangerouslySetInnerHTML={{__html: cleanStandardData(data.directorios)}}></span></div>
                            }

                            { data.ha_participado_en_mesas_sectoriales_en_los_ultimos.snippet === 'No' || data.ha_participado_en_mesas_sectoriales_en_los_ultimos.snippet === null 
                                ? <div></div>
                                : <div><h4>Mesas sectoriales</h4><span dangerouslySetInnerHTML={{__html: cleanStandardData(data.mesas_sectoriales)}}></span></div>
                            }
                            <div>
                                <h4>Datos de contacto</h4>
                                {
                                    data.incorporar_link_portal_del_investigador_anid.snippet === null || data.incorporar_link_portal_del_investigador_anid.snippet === ""
                                    ? ""
                                    : <span>
                                        { <a className="link" href={data.incorporar_link_portal_del_investigador_anid.raw} rel="noopener noreferrer" target="_blank">Perfil ANID</a> }</span>
                                }
                                {
                                    data.link_portal_scopus.snippet === null || data.link_portal_scopus.snippet === ""
                                    ? ""
                                    : <span>{ <br/>}{<a className="link" href={data.link_portal_scopus.raw} rel="noopener noreferrer" target="_blank">Perfil SCOPUS </a> }</span>
                                }
                                {
                                    data.link_linked.snippet === null || data.link_linked.snippet === ""
                                    ? ""
                                    : <span>{<br/>}{<a className="link" href={data.link_linked.snippet} rel="noopener noreferrer" target="_blank">Perfil Linked In </a>}</span>
                                }
                                <br/>

                                {
                                    data.id_orcid?.snippet
                                    && (
                                        <div>
                                            <a className="link" rel="noopener noreferrer" target="_blank" href={ `${data.id_orcid.snippet}` }>Código orcid</a>
                                        </div>
                                    )
                                }

                                {!(data.incorporar_link_portal_del_investigador_anid.snippet === null || data.incorporar_link_portal_del_investigador_anid.snippet === "") ||
                                        !(data.link_portal_scopus.snippet === null || data.link_portal_scopus.snippet === "") ||
                                        !(data.link_linked.snippet === null || data.link_linked.snippet === "")
                                        ? <span><br/><br/></span>:""}
                                    
                                
                                <div className='email'>
                                        Correo electronico: <a className="link" href={ `mailto:${data.email?.raw}` }>{ data.email.raw } </a>
                                </div>
                                {/* universidades_engineData.filter( u => u.id.toUpperCase() === universidad.raw.toUpperCase())[0]?.contacto */}
                               
                                                                    
                            </div>
                        </TabPanel>

                        {/* Investigacion */}
                        <TabPanel>
                            <div>
                                {
                                    data.investigacion.raw.map( (element, index) => {
                                        let elementJSON = JSON.parse(element)
                                        return (
                                            <div key={index}>
                                                <h4 style={{paddingLeft: '20px'}}>{elementJSON['nombre_de_la_linea_de_investigacion']}</h4>
                                                <div>
                                                    <p style={{paddingLeft: '20px'}}>{elementJSON['desarrollo_soluciones_que_permitan_abordar_los_desafios_o_problematicas']}</p>
                                                </div>
                                                <ul>
                                                    {<li> <b>Industrias:</b> {elementJSON['industrias']?.split(';').map((element,index) => {
                                                        console.log('industria:'+element);
                                                        let industria = element;
                                                        return <div style={{backgroundColor:'white', margin:'3px' ,border: '1px solid lightgrey', borderRadius:'3px', padding:'2px', display:'inline-block'}} key={index}>{industria}</div>
                                                        
                                                    })}</li>}
                                                    
                                                </ul>
                                            </div>
                                        )
                                    })
                                }                                                                    
                            </div>
                        </TabPanel>

                        {/* Publicaciones */}
                        <TabPanel>

{/*                             {
                                    data.presentaciones_orales_en_congresos_internacionales.raw === ""
                                ?   <div></div>
                                :    <div>
                                        <h4>Presentaciones orales en congresos internacionales</h4>
                                        <span dangerouslySetInnerHTML={{__html: data.presentaciones_orales_en_congresos_internacionales.snippet}}></span>
                                    </div>

                            } */}
                            <div>
                                {
                                    data.investigadores_anid.snippet===null?
                                    <div></div>:
                                    <h4>Publicaciones científicas</h4>
                                }
                            
                                {data.investigadores_anid.raw.map( (element, index) => {
                                        let publicacion = JSON.parse(element)
                                        const showPublicacion = publicacion["tipo_publicacion"].toLowerCase().includes("proyecto") ? false : true;
                                        return (
                                            showPublicacion &&
                                            (
                                                <div key={index}>
                                                    <div><a className="link link--800" href={publicacion["link_publicacion"]} rel="noopener noreferrer" target="_blank">{  publicacion["titulo_publicacion"]}</a></div>
                                                    {
                                                        publicacion["colaboradores"]==="null"?
                                                        <></>
                                                        :<div>
                                                                {/* year */}
                                                                <div>
                                                                    { publicacion["publicado_en"] && `${publicacion["publicado_en"]}` }
                                                                    { ( publicacion["lugar_anio_publicacion"] && publicacion["publicado_en"]) && ', ' }
                                                                    { publicacion["lugar_anio_publicacion"]  && `${ publicacion["lugar_anio_publicacion"] } ` }
                                                                </div>
                                                                <div>
                                                                { !isDataEmpy( publicacion["colaboradores"]?.replace(';','') ) && publicacion["colaboradores"]?.replace(';', ',')  }
                                                                </div>

                                                                <div>
                                                                { !isDataEmpy( publicacion["resumen"] )   &&  `${publicacion["resumen"] }`} { publicacion["resumen"]?.length === 150 && '...'}
                                                                </div>
                                                         </div>
                                                    }

                                                    <br></br>
                                                </div>
                                            )
                                        )
                                    })
                                }
                                
                            </div>

                        </TabPanel>
                        {/* Proyectos */}
                        <TabPanel>
                            {
                                data.proyectos?.raw.map( ( proyectoJSON, index ) =>
                                    {
                                        const proyecto = JSON.parse(proyectoJSON);
                                        return (
                                            <>
                                                <div key={ index }>
                                                    <h4>
                                                        { proyecto.proyecto }
                                                    </h4>
                                                    {
                                                        (proyecto.fuente_financiacion === null || proyecto.fuente_financiacion === "")
                                                            ? <></>
                                                            : (
                                                                <div>
                                                                    <span>Fuente Financiamiento: {proyecto.fuente_financiacion}</span>
                                                                </div>
                                                            )
                                                    }

                                                    {
                                                        (proyecto.anio_publicacion === null || proyecto.anio_publicacion === "" || !proyecto.anio_publicacion)
                                                            ? <></>
                                                            : (
                                                                <div>
                                                                    <span>Año de adjudicación: {proyecto.anio_publicacion}</span>
                                                                </div>
                                                            )
                                                    }
                                                </div>
                                            </>

                                        )
                                    })
                            }
                        </TabPanel>

                        {/* Propiedad intelectual */}
                        <TabPanel>
                            {
                                data.pi?.raw.map( (element, index) => {
                                    let pi = JSON.parse(element);
                                    return (
                                            <div key={index}>
                                                <p style={ { margin:'0' } } className="link link--800"> { pi.titulo } </p>
												<div>
													<span>
													    Año: { pi.anio_solicitud }
													</span>
												</div>
												
												<div>
													<span>
													    Número de Solicitud: { pi.nro_solicitud }
													</span>
												</div>
												
												<div>
													<span>
													    { pi.observaciones }
													</span>
												</div>
												
												<div>
													<span>
                                                        Autor(es): { pi.solicitante_adicional }
													</span>
												</div>
												<br></br>
                                            </div>
                                    )
                                })
                            }
                        </TabPanel>
                        {/* Centros */}
                        <TabPanel>
                            <div>
                                { data.centro.raw === null || data.centro.raw === "N/A" || data.centro.raw === '' || data.centro.raw === "N" ?
                                    null
                                    :
                                    (
                                        <>
                                            <span
                                                dangerouslySetInnerHTML={{__html: data.centro.raw || ''}}>
                                            </span>
                                        </>

                                    )
                                }
                            </div>
                        </TabPanel>
                    </Tabs>
                </div>
            </div>
        </>

        : <p>{ dataLabel }</p>
    )
}